import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-flush mt-6 mt-xl-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder mb-1" }, " Job's worker rates ")
  ])
], -1)
const _hoisted_3 = { class: "card-body pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_RatesDataTable = _resolveComponent("RatesDataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
        : (_openBlock(), _createBlock(_component_RatesDataTable, {
            key: _ctx.key,
            onSaveRates: _ctx.handleSaveRates,
            onUpdateState: _ctx.rerenderTableElement,
            "is-saving-rates": _ctx.isSavingRates
          }, null, 8, ["onSaveRates", "onUpdateState", "is-saving-rates"]))
    ])
  ]))
}